import React from 'react';
import {AlertTriangle, Trash2, X} from "lucide-react";
import {Button} from "./ui/Button";

interface ConfirmModalProps {
    isOpen: boolean;
    title?: string;
    showDeleteButton?: boolean;
    message: string;
    onConfirm?: () => void;
    onCancel: () => void;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
                                                              isOpen,
                                                              title,
                                                              showDeleteButton,
                                                              message,
                                                              onConfirm,
                                                              onCancel
                                                          }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-[2px] flex items-center justify-center z-50 p-4 animate-fade-in animate-duration-150">
            <div className="bg-surface border border-border rounded-2xl p-6 w-full max-w-sm shadow-lg animate-zoom-in animate-duration-200">
                <div className="flex items-start gap-3 mb-2">
                    {showDeleteButton && (
                        <div className="size-10 shrink-0 rounded-full bg-error-tint flex items-center justify-center">
                            <AlertTriangle size={18} className="text-error"/>
                        </div>
                    )}
                    <div>
                        {title && <h2 className="text-base font-display font-bold text-ink">{title}</h2>}
                        <p className="text-sm text-ink-muted mt-1">{message}</p>
                    </div>
                </div>
                <div className="flex justify-end gap-2 mt-6">
                    <Button variant="secondary" size="sm" icon={X} onClick={onCancel}>
                        Cancel
                    </Button>
                    {showDeleteButton && (
                        <Button variant="danger" size="sm" icon={Trash2} onClick={onConfirm}>
                            Delete
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
};
